module.exports = __webpack_public_path__ + "img/password-change.2eab5336.png";